/*
 * Lieferzonen-Rechner v2  ·  Kirchberger Metall
 * ==================================================================
 * Der Kunde gibt seine Postleitzahl ein, das Skript ermittelt die Frachtzone
 * und setzt die passende Lieferoption. Die Zonentabelle enthält ausschliesslich
 * Postleitzahlen und Zonennummern – der Versandort steht nicht darin.
 *
 * ARBEITSWEISE
 * ------------
 * Das Kaufformular übermittelt zweierlei:
 *   - versteckte Felder name="option1|2|3" mit der ID des jeweiligen
 *     Optionswerts, die über das Attribut form="…" am Formular hängen,
 *   - ein Feld name="id" mit der Varianten-ID.
 * Serverseitig rendert Focal das id-Feld als disabled; die Variantenauswahl
 * ersetzt es beim Laden durch ein aktives Feld mit der aufgelösten Variante.
 * Beim Aufruf von /cart/add hat id Vorrang vor den option-Feldern – gesetzt
 * werden deshalb BEIDE, sonst landet die zuerst gerenderte Variante im Korb.
 *
 * Geschrieben wird ausschliesslich in Feldwerte, ohne ein Ereignis auszulösen.
 * Focal baut die Kaufbox nur bei einem change-Ereignis im Kaufformular neu auf
 * – ohne Ereignis kein Neuaufbau, ohne Neuaufbau keine Schleife. Die
 * Endlosschleife der ersten Fassung (Klick auf Focals Auswahlliste ->
 * Neuaufbau -> Autofill -> Klick …) ist damit konstruktionsbedingt
 * ausgeschlossen. Zusätzlich wird die ID unmittelbar vor dem Absenden noch
 * einmal geschrieben, damit ein zwischenzeitlicher Teil-Neuaufbau sie nicht
 * überholen kann.
 *
 * Die Preisanzeige wird mit den serverseitig formatierten Beträgen aus dem
 * Snippet beschriftet. In JavaScript wird weder gerundet noch formatiert, damit
 * die Anzeige exakt der Währungsformatierung des Shops entspricht.
 *
 * Baut Focal die Kaufbox aus einem anderen Grund neu auf – Wechsel von
 * Beleuchtung oder Glasdekor – wird der Zustand aus window wiederhergestellt
 * und stillschweigend erneut gesetzt (siehe nachziehen()).
 */
(function () {
  'use strict';

  /*
   * Nur eine Instanz. Baut Focal die Kaufbox neu auf, wird das <script>-Tag
   * aus diesem Snippet mit eingefügt und der Browser führt die Datei erneut
   * aus. Ohne diese Sperre entstünde bei jedem Wechsel von Beleuchtung oder
   * Glasdekor eine weitere Instanz mit eigenem MutationObserver, eigenem
   * Zwischenspeicher der Zonentabelle und einem zusätzlichen Abruf davon.
   * Die erste Instanz genügt: ihr Beobachter erfasst auch das neu eingefügte
   * Widget.
   */
  if (window.__lieferzoneRechnerAktiv) return;
  window.__lieferzoneRechnerAktiv = true;

  var TABELLE = null;
  var LAEDT = null;

  /* Zustand am window, weil das Widget beim Neuaufbau der Kaufbox ersetzt wird. */
  var ZUSTAND = (window.__lieferzoneZustand = window.__lieferzoneZustand || {});

  function tabelleLaden(url) {
    if (TABELLE) return Promise.resolve(TABELLE);
    if (LAEDT) return LAEDT;
    LAEDT = fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) { TABELLE = d; return d; });
    return LAEDT;
  }

  function ziffern(s) { return (s || '').replace(/\D/g, ''); }

  /*
   * Geldbetrag im Format einer Vorlage ausgeben.
   *
   * Die Vorlage ist ein serverseitig von Shopify formatierter Betrag. Aus ihr
   * werden Dezimal- und Tausendertrennzeichen sowie Währungszeichen und deren
   * Stellung übernommen. Damit stimmt die Ausgabe immer mit der Formatierung
   * des Shops überein – Intl.NumberFormat täte das nicht: es setzt vor das
   * Euro-Zeichen ein schmales geschütztes Leerzeichen (U+202F), Shopify ein
   * gewöhnliches.
   */
  function geldNach(vorlage, cent) {
    var m = /\d[\d.,   ]*\d|\d/.exec(vorlage || '');
    if (!m) return null;
    var zahl = m[0];
    var dez = zahl.lastIndexOf(',') > zahl.lastIndexOf('.') ? ',' : '.';
    var grp = dez === ',' ? '.' : ',';
    var neg = cent < 0;
    var betrag = Math.abs(cent);
    var ganz = String(Math.floor(betrag / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, grp);
    var rest = String(betrag % 100);
    while (rest.length < 2) rest = '0' + rest;
    return vorlage.slice(0, m.index) + (neg ? '-' : '') + ganz + dez + rest +
           vorlage.slice(m.index + zahl.length);
  }

  /* Binäre Suche über die Breakpoint-Liste: [[startPLZ, zone], …], Zone 0 = ausserhalb. */
  function zoneFinden(daten, land, plz) {
    var t = daten.laender[land];
    if (!t) return null;
    var z = ziffern(plz);
    if (z.length < 3) return null;
    if (z.length > t.stellen) z = z.slice(0, t.stellen);
    while (z.length < t.stellen) z += '0';
    var idx = parseInt(z, 10);
    var bp = t.bp, lo = 0, hi = bp.length - 1;
    while (lo < hi) {
      var mid = (lo + hi + 1) >> 1;
      if (bp[mid][0] <= idx) lo = mid; else hi = mid - 1;
    }
    return bp[lo][1];
  }

  /* ---------------------------------------------------------------- Felder */

  /*
   * Alle Felder einer Option. Die Felder liegen NICHT im <form>-Element, sie
   * sind nur über das Attribut form="…" damit verbunden – deshalb wird im
   * ganzen Dokument gesucht und über die Formular-ID gefiltert. Ohne diesen
   * Filter würde auf der Produktseite auch das Schnellkauf-Formular getroffen.
   */
  function optionsFelder(formId, pos) {
    var alle = document.querySelectorAll('input[name="option' + pos + '"]');
    var treffer = [];
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].getAttribute('form') === formId) treffer.push(alle[i]);
    }
    return treffer;
  }

  function optionLesen(formId, pos) {
    var f = optionsFelder(formId, pos);
    for (var i = 0; i < f.length; i++) {
      if (f[i].type === 'radio' || f[i].type === 'checkbox') {
        if (f[i].checked) return f[i].value;
      } else {
        return f[i].value;
      }
    }
    return null;
  }

  /* Schreibt ohne Ereignis. Rückgabe: true, wenn ein Feld gefunden wurde. */
  function optionSchreiben(formId, pos, wertId) {
    var f = optionsFelder(formId, pos);
    if (!f.length) return false;
    var gesetzt = false;
    for (var i = 0; i < f.length; i++) {
      if (f[i].type === 'radio') {
        var soll = f[i].value === wertId;
        if (f[i].checked !== soll) f[i].checked = soll;
        if (soll) gesetzt = true;
      } else {
        if (f[i].value !== wertId) f[i].value = wertId;
        gesetzt = true;
      }
    }
    return gesetzt;
  }

  /* ------------------------------------------------------------------ Init */

  function init(el) {
    /* Bereits eingerichtet: nur nachziehen, was ein Teil-Neuaufbau zerstört hat. */
    if (el.dataset.lzInit === '1') {
      if (typeof el.__lzNachziehen === 'function') el.__lzNachziehen();
      return;
    }
    el.dataset.lzInit = '1';

    var konfig;
    try {
      konfig = JSON.parse(el.querySelector('[data-lz-konfig]').textContent);
    } catch (e) { return; }

    var wurzel = el.closest('product-rerender') || document;

    /*
     * Die ID des Kaufformulars kommt aus dem DOM, nicht aus dem Snippet:
     * {% render %} kapselt den Liquid-Scope, product_form_id ist dort nicht
     * sichtbar. <variant-picker> trägt sie als form-id, das Formular selbst
     * dient als zweite Quelle. Gesucht wird nur innerhalb dieser Kaufbox,
     * damit auf der Seite vorhandene Schnellkauf-Formulare nicht stören.
     */
    var picker = wurzel.querySelector('variant-picker[form-id]');
    var formEl = null;
    /*
     * Nicht das erste /cart/add-Formular nehmen: die Kaufbox enthält davor
     * noch das Formular für die Ratenzahlungs-Anzeige. Ausschlaggebend ist
     * der Warenkorb-Knopf. Und: form.id liefert nicht das id-Attribut,
     * sondern das Feld name="id" – Formulare bilden ihre Felder als
     * Eigenschaften ab. Deshalb getAttribute('id').
     */
    var kandidaten = wurzel.querySelectorAll('form[action*="/cart/add"]');
    for (var k = 0; k < kandidaten.length; k++) {
      if (kandidaten[k].querySelector('[data-product-add-to-cart-button]')) {
        formEl = kandidaten[k]; break;
      }
    }
    konfig.formId = (picker && picker.getAttribute('form-id')) ||
                    (formEl && formEl.getAttribute('id')) || konfig.formId || '';
    if (!konfig.formId) return;

    var eingabe = el.querySelector('[data-lz-plz]');
    var landWahl = el.querySelector('[data-lz-land]');
    var ausgabe = el.querySelector('[data-lz-ausgabe]');
    var abholung = el.querySelector('[data-lz-abholung]');
    var knopf = el.querySelector('[data-lz-berechnen]');

    var z = ZUSTAND['p' + konfig.produktId] || (ZUSTAND['p' + konfig.produktId] = {});
    if (z.zone === undefined) z.zone = null;   // null = offen, 0 = Abholung, 1..5 = Zone

    function melden(art, titel, zeile) {
      ausgabe.className = 'lz-ausgabe lz-' + art;
      ausgabe.innerHTML = (titel ? '<strong>' + titel + '</strong><br>' : '') + (zeile || '');
    }

    /* Aktuell gewählte Werte der übrigen Optionen, als Namen. */
    function andereWerte() {
      var namen = [];
      for (var i = 0; i < konfig.optionen.length; i++) {
        var o = konfig.optionen[i];
        if (o.pos === konfig.optionPos) { namen[o.pos - 1] = null; continue; }
        var id = optionLesen(konfig.formId, o.pos);
        var name = null;
        for (var j = 0; j < o.werte.length; j++) {
          if (String(o.werte[j].i) === String(id)) { name = o.werte[j].n; break; }
        }
        /* Kein Feld gefunden: ersten Wert annehmen, damit die Suche nicht leer läuft. */
        namen[o.pos - 1] = name !== null ? name : o.werte[0].n;
      }
      return namen;
    }

    function varianteFinden(zoneIndex) {
      var namen = andereWerte();
      namen[konfig.optionPos - 1] = konfig.zonen[zoneIndex].n;
      return konfig.varianten[[namen[0] || '', namen[1] || '', namen[2] || ''].join('~|~')] || null;
    }

    function preisSchreiben(text) {
      var p = wurzel.querySelector('.product-meta__price-list-container .price--large');
      if (!p) return;
      var knoten = null;
      for (var i = p.childNodes.length - 1; i >= 0; i--) {
        if (p.childNodes[i].nodeType === 3 && p.childNodes[i].textContent.trim()) {
          knoten = p.childNodes[i]; break;
        }
      }
      if (knoten) { if (knoten.textContent !== text) knoten.textContent = text; }
      else p.appendChild(document.createTextNode(text));
    }

    /*
     * Positionsmerkmal für den Warenkorb.
     *
     * Der Wert wird aus dem Zustand abgeleitet, nicht übergeben: das Feld wird
     * dem Formular per JavaScript hinzugefügt und verschwindet deshalb, sobald
     * Focal die Kaufbox neu aufbaut. Es muss also bei jedem Nachziehen erneut
     * gesetzt werden – sonst wäre nach einem Wechsel von Beleuchtung oder
     * Glasdekor zwar die richtige Variante im Korb, aber die Postleitzahl weg.
     *
     * Ohne ermittelte Zone bleibt das Feld abgeschaltet und wird nicht
     * übermittelt; im Warenkorb steht dann keine halbe Angabe.
     */
    function merkmalWert() {
      if (!konfig.plzInWarenkorb) return null;
      if (z.abholung) return null;
      if (z.zone === null || z.zone === undefined || z.zone === 0) return null;
      if (!z.plz) return null;
      return (z.land || 'DE') + ' ' + String(z.plz).trim().toUpperCase();
    }

    function merkmalSetzen() {
      if (!konfig.plzInWarenkorb) return;
      var formular = document.getElementById(konfig.formId);
      if (!formular) return;
      var name = 'properties[' + (konfig.merkmalName || 'Lieferort') + ']';
      var inp = formular.querySelector('input[name="' + name + '"]');
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = name;
        formular.appendChild(inp);
      }
      var wert = merkmalWert();
      if (inp.value !== (wert || '')) inp.value = wert || '';
      if (inp.disabled !== !wert) inp.disabled = !wert;
    }

    /*
     * Varianten-ID ins Kaufformular schreiben. Focal ersetzt das serverseitig
     * als disabled gerenderte Feld beim Laden durch ein aktives; beim Aufruf
     * von /cart/add hat es Vorrang vor den option-Feldern.
     */
    function variantenIdSchreiben(vid) {
      var formular = document.getElementById(konfig.formId);
      if (!formular || !vid) return;
      var inp = formular.querySelector('input[name="id"]');
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'id';
        formular.appendChild(inp);
      }
      if (inp.disabled) inp.disabled = false;
      if (inp.value !== String(vid)) inp.value = String(vid);
    }

    /* Rückfallebene zum CSS-Ausblenden, für Browser ohne :has(). */
    function auswahlVerstecken() {
      var f = optionsFelder(konfig.formId, konfig.optionPos);
      if (!f.length) return;
      var huelle = f[0].closest('.product-form__option-selector');
      if (huelle && !huelle.hasAttribute('hidden')) huelle.setAttribute('hidden', 'hidden');
    }

    /*
     * Pflichtfeld-Wache. Der Abbruch läuft in der Erfassungsphase mit
     * stopImmediatePropagation, sonst führt Focals eigener submit-Handler den
     * Warenkorb-Aufruf trotzdem aus. Die Wache wird bei jedem Nachziehen neu
     * gesetzt, weil ein Teil-Neuaufbau das Formularelement austauschen kann.
     */
    function wacheSetzen() {
      var formular = document.getElementById(konfig.formId);
      if (!formular || formular.dataset.lzWache === '1') return;
      formular.dataset.lzWache = '1';
      formular.addEventListener('submit', function (e) {
        if (!z.gesperrt) { nachziehen(); return; }
        e.preventDefault();
        e.stopImmediatePropagation();
        el.classList.add('lz-mahnung');
        setTimeout(function () { el.classList.remove('lz-mahnung'); }, 2000);
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (eingabe && !eingabe.disabled) eingabe.focus();
        if (z.zone === null && ausgabe.className.indexOf('lz-anfrage') === -1) {
          melden('fehler', konfig.texte.pflichtTitel, konfig.texte.pflichtText);
        }
      }, true);
    }

    /*
     * Setzt Optionswert, Varianten-ID, Preisanzeige und Positionsmerkmal neu –
     * ohne Ereignis, ohne den Zustand zu verändern und ohne die Meldung zu
     * überschreiben. Idempotent.
     */
    function nachziehen() {
      auswahlVerstecken();
      wacheSetzen();
      var idx = (z.zone === null || z.zone === undefined) ? 0 : z.zone;
      var v = varianteFinden(idx);
      optionSchreiben(konfig.formId, konfig.optionPos, String(konfig.zonen[idx].i));
      if (v) { variantenIdSchreiben(v.i); preisSchreiben(v.p); }
      merkmalSetzen();
      return v;
    }
    el.__lzNachziehen = nachziehen;

    function kaufSperren(gesperrt) { z.gesperrt = !!gesperrt; }

    /*
     * Aufpreistext für eine Zone.
     *
     * Die Bruttopreise entstehen durch Rundung von netto x 1,19 je Variante.
     * Die Differenz zweier gerundeter Beträge kann deshalb um einen Cent von
     * der im Snippet hinterlegten Referenz abweichen. Deshalb wird der Aufpreis
     * aus den Preisen der tatsächlich gewählten Kombination gebildet – nur wenn
     * das nicht gelingt, greift die Referenz aus dem Snippet.
     */
    function aufpreisText(zoneIndex) {
      var basis = varianteFinden(0);
      var jetzt = varianteFinden(zoneIndex);
      if (basis && jetzt && typeof basis.c === 'number' && typeof jetzt.c === 'number') {
        if (jetzt.c === basis.c) return null;              // kein Aufpreis
        if (geldNach(basis.p, basis.c) === basis.p) {      // Formatvorlage trägt
          return geldNach(basis.p, jetzt.c - basis.c);
        }
      }
      return konfig.zuschlaege[zoneIndex] || null;
    }

    /* ------------------------------------------------------------- Ablauf */

    function aufAnfrage() {
      z.zone = null;
      nachziehen();
      kaufSperren(true);
      melden('anfrage', konfig.texte.anfrageTitel,
        konfig.texte.anfrageText + ' <a href="' + konfig.kontaktUrl + '">' +
        konfig.texte.anfrageLink + '</a>');
    }

    function aufAbholung() {
      z.zone = 0;
      nachziehen();
      kaufSperren(false);
      melden('ok', konfig.texte.abholungTitel, konfig.texte.abholungText);
    }

    function aufGrundpreis() {
      z.zone = null;
      nachziehen();
      kaufSperren(true);
      melden('leer', '', konfig.texte.hinweis);
    }

    function pruefen() {
      if (abholung && abholung.checked) { z.abholung = true; aufAbholung(); return; }
      z.abholung = false;

      var plz = eingabe.value.trim();
      var land = landWahl ? landWahl.value : 'DE';
      z.plz = plz;
      z.land = land;

      if (ziffern(plz).length < 3) { aufGrundpreis(); return; }
      melden('laedt', '', konfig.texte.laedt);

      tabelleLaden(konfig.tabelleUrl).then(function (daten) {
        var zone = zoneFinden(daten, land, plz);
        if (zone === null || zone === 0 || zone >= konfig.zonen.length) { aufAnfrage(); return; }

        z.zone = zone;
        if (!nachziehen()) { aufAnfrage(); return; }
        kaufSperren(false);

        var auf = aufpreisText(zone);
        var zeile = auf === null ? konfig.texte.ohneAufpreis
                                 : konfig.texte.aufpreis.replace('{preis}', auf);
        melden('ok', konfig.texte.okTitel.replace('{plz}', plz.toUpperCase()), zeile);
      }).catch(aufAnfrage);
    }

    /* ---------------------------------------------------------- Ereignisse */

    var timer = null;
    eingabe.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(pruefen, 300);
    });
    eingabe.addEventListener('change', pruefen);
    eingabe.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); pruefen(); }
    });
    if (landWahl) landWahl.addEventListener('change', pruefen);
    if (knopf) knopf.addEventListener('click', pruefen);
    if (abholung) abholung.addEventListener('change', function () {
      eingabe.disabled = abholung.checked;
      if (knopf) knopf.disabled = abholung.checked;
      pruefen();
    });

    /* ------------------------------------------- Zustand wiederherstellen */

    if (z.abholung) {
      if (abholung) abholung.checked = true;
      eingabe.disabled = true;
      if (knopf) knopf.disabled = true;
      aufAbholung();
    } else if (z.plz) {
      if (landWahl && z.land) landWahl.value = z.land;
      eingabe.value = z.plz;
      pruefen();
    } else {
      aufGrundpreis();
    }
  }

  function alleInitialisieren() {
    var n = document.querySelectorAll('[data-lieferzone-rechner]');
    for (var i = 0; i < n.length; i++) init(n[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alleInitialisieren);
  } else {
    alleInitialisieren();
  }
  document.addEventListener('shopify:section:load', alleInitialisieren);

  /*
   * Focal tauscht beim Variantenwechsel Teile der Kaufbox aus, ohne dabei
   * shopify:section:load auszulösen. Der Beobachter fängt das ab. init() und
   * nachziehen() sind idempotent, mehrfaches Auslösen ist deshalb folgenlos.
   */
  var anstehend = null;
  new MutationObserver(function () {
    clearTimeout(anstehend);
    anstehend = setTimeout(alleInitialisieren, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();